import { QRCodeCanvas } from '@cheprasov/qrcode';
import { COLOURS } from '../../../ui-kit';
import Iris from '../../../assets/images/logo-iris.svg';
import { QR_CODE_IMAGE_STYLE } from '../styles/qrCodeImageStyles';

const qrCodeCanvas = (url) => new QRCodeCanvas(url, {
  fgColor: COLOURS.grey.denim,
  image: {
    source: Iris,
    ...QR_CODE_IMAGE_STYLE
  }
});

export const getUrlQRCode = (url) => {
  const qrCanvas = qrCodeCanvas(url);
  return qrCanvas.toDataUrl();
};